// extracted by mini-css-extract-plugin
export default {"card":"PaymentMethod_card__wF5lC"};